import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { AuftragsKomponente } from 'src/app/api/model/swagger-model';
import { Auftragdetails } from '../auftragdetails.helper';
import { KomponenteBase } from './komponente';

const log = new Logger("AuftragLeergutComponent");

@Component({
    selector: 'auftrag-leergut-komponente',
    template: `
        <div class="auftrag-leergut-komponente">
          <div class="section ion-activatable" appClick (clicked)="onLeergutClicked($event)" [class.section-invalid]="!(auftragdetails.istLeergutVollstaendig | async)">
            <h1>{{ getEinstellung('Titel', 'Leergut') }} <span *ngIf="!(auftragdetails.istLeergutVollstaendig | async)" class="nicht-vollstaendig">{{ 'BitteEingabePruefen' | translate }}</span></h1>
            <div class="leergut-liste">
              <app-leergut [auftragdetails]="auftragdetails" [auftrag]="auftrag" [formularkonfiguration]="leergutFormularkonfiguration" #appLeergut></app-leergut>
            </div>
          </div>
        </div>
    `,
    styles: [`
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragLeergutComponent extends KomponenteBase implements OnInit {

    @Input() auftragdetails: Auftragdetails;
    @Input() komponente: AuftragsKomponente;

    leergutFormularkonfiguration: AuftragsKomponente;

    constructor(
        private router: Router,
        protected cdr: ChangeDetectorRef) {
        super(cdr);
    }

    ngOnInit() {
        log?.debug('ngOnInit');

        this.leergutFormularkonfiguration = this.auftragdetails?.formularKonfiguration?.komponenten?.find(p => p.name === 'Leergut');

        super.ngOnInit();
    }

    async onLeergutClicked(e: TouchEvent) {
        log?.debug('onLeergutClicked', e);

        if (e.target) {
            const element = e.target as HTMLElement;

            if (element.tagName && element.tagName.toUpperCase() == "ION-BUTTON") {
                // Ignorieren. Es wurde auf einen Plus/Minus-Button geklickt
                return;
            }
        }

        this.auftragdetails.leergutAendern();
    }
}
